(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var menuToggle = document.querySelector('.header__menu-toggle');
    var mobileMenu = document.querySelector('.header__mobile-menu');
    if (!menuToggle || !mobileMenu) return;

    function setOpen(open) {
      mobileMenu.classList.toggle('active', open);
      menuToggle.classList.toggle('active', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Scroll lock: the page used to scroll behind the open menu.
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    menuToggle.addEventListener('click', function () {
      setOpen(!mobileMenu.classList.contains('active'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
        setOpen(false);
        menuToggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!mobileMenu.classList.contains('active')) return;
      if (mobileMenu.contains(e.target) || menuToggle.contains(e.target)) return;
      setOpen(false);
    });

    // Reset when resizing up to the desktop nav.
    window.addEventListener('resize', function () {
      if (window.innerWidth > 768 && mobileMenu.classList.contains('active')) {
        setOpen(false);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Keep the displayed price in sync with the selected variant. Previously the
  // page kept showing the default variant's price after changing the select.
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.product-form__select');
    if (!select) return;
    var root = select.closest('.product');
    if (!root) return;
    var opt = select.options[select.selectedIndex];
    var priceEl = root.querySelector('.product__price--current, .product__price--sale');
    var raw = opt && opt.getAttribute('data-variant-price');
    if (priceEl && raw) priceEl.textContent = raw;
    var submit = root.querySelector('.product-form__submit');
    if (submit) {
      var unavailable = opt && opt.disabled;
      submit.disabled = !!unavailable;
    }
  });

  document.addEventListener('click', function(e) {
    var thumbnail = e.target.closest && e.target.closest('.product__thumbnail');
    if (!thumbnail) return;
    var gallery = thumbnail.closest('.product__gallery');
    if (!gallery) return;
    var mainImg = gallery.querySelector('.product__main-image img');
    if (!mainImg) return;
    var url = thumbnail.getAttribute('data-product-image-url');
    if (!url) return;
    e.preventDefault();
    gallery.querySelectorAll('.product__thumbnail').forEach(function(b) {
      b.classList.remove('product__thumbnail--active');
    });
    thumbnail.classList.add('product__thumbnail--active');
    mainImg.src = url;
  });

  } catch(e) { console.error(e); }
})();
})();
